// src/hooks/useIsMobile.js
import { useState, useEffect } from 'react';

export const useIsMobile = () => {
    // Initialize based on current window width
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

    useEffect(() => {
        const handleResize = () => {
            // Update state based on width (matches the CSS media queries)
            setIsMobile(window.innerWidth <= 800);
        };

        // Listen for window resize events
        window.addEventListener('resize', handleResize);
        
        // Cleanup listener
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};